import { Update, UpdateCategory } from '../types';

/**
 * Presentatie-metadata per updatecategorie (chip-kleuren + fallback-label).
 *
 * De kleuren/CSS worden altijd op `category` bepaald. Het `label` is enkel een
 * fallback voor wanneer de feed nog geen server-gelokaliseerd `categoryLabel`
 * meestuurt — toon bij voorkeur `update.categoryLabel` via `categoryLabelFor`.
 */
export const CATEGORY_META: Record<UpdateCategory, { label: string; bg: string; color: string }> = {
    nieuw: { label: 'Nieuw', bg: 'var(--accent-tint)', color: 'var(--accent-on)' },
    verbeterd: { label: 'Verbeterd', bg: 'var(--success-bg)', color: 'var(--success)' },
    aankondiging: { label: 'Aankondiging', bg: 'var(--warning-bg)', color: 'var(--warning)' },
};

/** Chip-kleuren voor een categorie, met neutrale fallback voor onbekende waarden. */
export function categoryStyleFor(category: UpdateCategory): { bg: string; color: string } {
    return CATEGORY_META[category] ?? { bg: 'var(--bg-surface-alt)', color: 'var(--text-muted)' };
}

/**
 * Toonbaar categorielabel: bij voorkeur het server-gelokaliseerde `categoryLabel`,
 * anders het eigen fallback-label, anders de kale categoriesleutel.
 */
export function categoryLabelFor(update: Pick<Update, 'category' | 'categoryLabel'>): string {
    return update.categoryLabel?.trim() || CATEGORY_META[update.category]?.label || update.category;
}

/** Toont een datum als bijv. "24 juni 2026". */
export function formatUpdateDate(iso: string): string {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' });
}
